module.exports = __webpack_public_path__ + "8a3e4fc19f20e7fa3c9cb372e16e1bf4.pdf";